/**
 * Feature flags for MVP. Enable when backend/features are production-ready.
 * MVP: auth, dashboard, tasks, calendar, team, analytics, settings.
 */
export const FEATURE_FLAGS = {
  /** Content / Social posting – not ready for production */
  content: false,
  /** Pricing / Stripe – plans page visible but checkout not wired */
  pricingPage: true,
  /** Image AI – hide from nav if not ready */
  imageEditor: false,
} as const;
